import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../../assets/img/contact_banner.png';
const _withScopeId = n => (_pushScopeId("data-v-2df1856d"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "wrap"
};
const _hoisted_2 = {
  class: "web-banner"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1));
const _hoisted_4 = {
  class: "banner-word flex align-items"
};
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "合作共赢", -1));
const _hoisted_6 = {
  class: "contact-us-column"
};
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "company-address"
}, null, -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_top_header = _resolveComponent("top-header");
  const _component_van_sticky = _resolveComponent("van-sticky");
  const _component_van_button = _resolveComponent("van-button");
  const _component_van_config_provider = _resolveComponent("van-config-provider");
  const _component_contact_us = _resolveComponent("contact-us", true);
  const _component_bottom_foot = _resolveComponent("bottom-foot");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_van_sticky, null, {
    default: _withCtx(() => [_createVNode(_component_top_header, {
      scenario: $data.scenario
    }, null, 8, ["scenario"])]),
    _: 1
  }), _createElementVNode("div", _hoisted_2, [_hoisted_3, _createElementVNode("div", _hoisted_4, [_hoisted_5, _createVNode(_component_van_config_provider, {
    "theme-vars": $setup.themeVars
  }, {
    default: _withCtx(() => [_createVNode(_component_van_button, {
      type: "primary",
      round: "",
      color: "#16A0F0"
    }, {
      default: _withCtx(() => [_createTextVNode("联系我们")]),
      _: 1
    })]),
    _: 1
  }, 8, ["theme-vars"])])]), _createElementVNode("div", _hoisted_6, [_createVNode(_component_contact_us), _hoisted_7]), _createVNode(_component_bottom_foot)]);
}